import { render, staticRenderFns } from "./DoKoStackCards.vue?vue&type=template&id=16dffb54&scoped=true&"
import script from "./DoKoStackCards.vue?vue&type=script&lang=ts&"
export * from "./DoKoStackCards.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoStackCards.vue?vue&type=style&index=0&id=16dffb54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dffb54",
  null
  
)

/* custom blocks */
import block0 from "./DoKoStackCards.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports